// extracted by mini-css-extract-plugin
export var standaloneTable = "_fe-0";
export var standaloneTableWithBodyFill = "_fe-1";
export var withExtraHeader = "_fe-2";